/* eslint-disable react/prop-types */
import { Pagination } from "@mui/material";
import { useEffect, useState } from "react";
import { API_ROUTES, API_URL, PermissionMenuKey } from "../../utils/constants";
import axios from "axios";
import LoadingCircle from "components/LoadingCircle/loadingCircle";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { LinkImage } from "../../utils";

export default function NewsList(dataNews) {
  const pageSize = 9;
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState();
  const [pageState, setPageState] = useState(1);
  const [pageCountState, setPageCountState] = useState(1);

  useEffect(() => {
    const getDataTinTuc = async (trangthai, page) => {
      setIsLoading(true);
      try {
        const response = await axios.get(API_ROUTES.TINTUC, {
          params: {
            trangthai: trangthai,
            pageNumber: page,
            countNumber: pageSize,
          },
        });
        setData(response.data?.data);
        setPageCountState(Math.ceil(response.data?.totalRecord / pageSize));
        setIsLoading(false);
      } catch (error) {
        if (error.response && error.response.status === 500) {
          setAlert({
            alert: true,
            message: "Đã xảy ra lỗi 500. Vui lòng thử lại sau.",
            type: "error",
          });
        } else {
          console.log(error.response);
        }
        setIsLoading(false);
        return;
      }
    };
    getDataTinTuc("published", pageState);
  }, [pageState]);

  const handleChangePage = (e, page) => {
    setPageState(page);
  };
  const handleToDetailNews = (post) => (e) => {
    const { id, slug } = post;
    navigate(`/${PermissionMenuKey.tinTuc}/${slug}?id=${id}`);
  };
  return (
    <div className="bg-white py-4">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="border-b border-gray-300">
          <h5 className="text-md font-bold tracking-tight text-gray-900">
            Tin tức
          </h5>
        </div>
        {isLoading && (
          <div className="flex items-center justify-center mt-8">
            <LoadingCircle />
          </div>
        )}
        {!isLoading && data && data.length == 0 && (
          <div>Đang cập nhập tin tức. Vui lòng chờ trong giây lát!</div>
        )}
        {!isLoading && data && data.length > 0 && (
          <>
            <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-8 pt-8 lg:mx-0 lg:max-w-none lg:grid-cols-3">
              {data.map((post) => (
                <article
                  key={post?.id + "postItem"}
                  className="flex max-w-xl flex-col items-start justify-between border border-gray-300 p-4 rounded-xl"
                  onClick={handleToDetailNews(post)}
                >
                  <div className="flex items-center gap-x-4 text-xs">
                    <time
                      dateTime={post?.ngayxuatban}
                      className="text-gray-500"
                      lang="vi"
                    >
                      {dayjs(post?.ngayxuatban).isValid()
                        ? dayjs(post?.ngayxuatban).format("DD/MM/YYYY")
                        : post?.ngayxuatban}
                    </time>
                  </div>

                  {post?.anhdaidien ? (
                    <img
                      className="w-full h-40 object-cover rounded-md mt-2"
                      src={API_URL + "/media/" + post?.anhdaidien}
                      alt={post?.anhdaidien}
                      loading="lazy"
                      width={1024}
                      height={1024}
                    />
                  ) : (
                    <div className="w-full h-40 bg-gray-500 rounded-md mt-2">
                      <img
                        className="w-full h-40 object-cover rounded-md mt-2"
                        src={LinkImage.pictureDefault}
                        alt="no-image"
                        loading="lazy"
                        width={1024}
                        height={1024}
                      />
                    </div>
                  )}

                  <div className="group relative">
                    <h3 className="mt-3 text-lg font-semibold leading-6 text-gray-900 group-hover:text-gray-600 hover:underline">
                      <div className="line-clamp-3">{post?.tieude}</div>
                    </h3>
                  </div>
                  <div className="relative mt-4 flex items-center gap-x-4">
                    <div className="text-sm leading-6">
                      <div className="font-semibold text-red-500">
                        <div>
                          <span className="absolute inset-0" />
                          {post?.tacgia}
                        </div>
                      </div>
                    </div>
                  </div>
                </article>
              ))}
            </div>
            <div className="mt-4 mx-auto flex justify-center">
              <Pagination
                count={pageCountState}
                color="primary"
                page={pageState}
                onChange={handleChangePage}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
}
